import React  from 'react';
import styled from 'styled-components';
import { IconEdit } from '../../Assets/panels/IconEdit';
import { IconTrash } from '../../Assets/panels/IconTrash';
import { TextBtnSmall } from '../Inputs/TextBtnSmall';
import { DictioneryPanel } from '../../Data/DictioneryPanel';

const Styles = styled.div`
    /* flex-grow: 1; */
    margin: 1px 0 0;
    padding: 1rem;
    display: flex;
    align-items: center;
    gap: 2rem;
    position: relative;
    border-radius: var(--border-radius-3);
    background-color: var(--n-grey-0);
    text-decoration: none;
    box-shadow: 0px 23px 40px -13px #00000014;
    &::before {
        content: "";
        z-index: -1;
        position: absolute;
        inset: -1px;
        background: linear-gradient(180deg, #E5E5E5 0%, #E5E5E500 100%);
        border-radius: calc(var(--border-radius-3) + 1px);
    }
    .image {
      width: 230px;
      aspect-ratio: 1.8;
      overflow: hidden;
      border-radius: var(--border-radius-2);
      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .data {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      .name {
        font-size: 1.25;
        font-weight: 700;
      }
    }
    .expand {
      flex-grow: 1;
    }
    .actions {
      display: flex;
      gap: 0.5rem;
    }
    @media screen and (max-width: 850px) {
      gap: 0.5rem;
      .image {
        width: 30%;
        aspect-ratio: 1;
      }
      .actions {
        flex-direction: column;
      }
    }
`
export default function HotelCart (props){
  const {v, i, lang="en", agenciesData = {}, editFunc=()=>{}, deleteFunc=()=>{}, noKey=false} = props;
  let name = v.Hotel_En_Name;
  if(lang === "fa"){
    name = v.Hotel_Name
  }

  return (
    <Styles key={i} to={"/" + lang + "/agency-panel/"+ agenciesData.Agency_Id +"/hotels"}>
      <div className='image'>
        {
          (v.Hotel_Logo) ? (
            <img src={v.Hotel_Logo}/>
          ) : ""
        }
      </div>
      <div className='data'>
        <div className='name'>
          {name}
        </div>
        <div className='loc'>
          {v.Country_Name} - {v.City_name}
        </div>
      </div>
      <div className='expand'></div>
      <div className='actions'>
        {
          (!noKey)? (
            <>
              <TextBtnSmall
                newType={1}
                onclick={editFunc}
                text={
                <div className='with-icon'>
                    <IconEdit/> {DictioneryPanel.accessDict.edit[lang]}
                </div>
                }
            />
            <TextBtnSmall
                newType={1}
                onclick={deleteFunc}
                text={
                <div className='with-icon'>
                    <IconTrash/> {DictioneryPanel.accessDict.trash[lang]}
                </div>
                }
            />
            </>
          ) : ""
        }
        
    </div>
    </Styles>
  )
}

